export function getForwardPaymentIntentId(orderId){
  const key = `forwardPaymentIntentId-${orderId}`;
  const value = localStorage.getItem(key);


  if (!value || value === 'undefined') {
    localStorage.removeItem(key);
    if (value === 'undefined') {
      console.error(`Forward PaymentIntentId is: ${value} for orderId: ${orderId}`);
    }
    return null;
  }

  return value;
}
